import { http } from '@/system/http';
import swal from 'sweetalert';

export const moveTeamMeetingRequest = (meeting, revertFunction, applyRecurringActionTo) => {
    const newMeetingData = {
        start_date: meeting.start.format('YYYY-MM-DD'),
        start_time: meeting.start.format('HH:mm:ss'),
        end_date: meeting.end.format('YYYY-MM-DD'),
        end_time: meeting.end.format('HH:mm:ss'),
    }

    const config = applyRecurringActionTo
        ? { params: { action: applyRecurringActionTo } }
        : null;

    return http.post(`/app/team-meetings/meetings/${meeting.id}/move`, newMeetingData, config)
        .then(( response) => {
            toastr.success(response.data.success);
            return response;
        })
        .catch(({ error } ) => {
            revertFunction();
            setTimeout(() => {
                swal(error.response.data.status, error.response.data.message, 'warning');
            }, 500);
        });
}

// todo: move all team meeting related requests to this file
